import { type Store as StoreBase, storeCreate as storeCreateBase } from '@subaio/utils'
import { type ContainerState, ContainerStatus } from '@subaio/webapp/src/containers'

export type UserAuth =
	| { status: 'authenticated'; token: string; refreshToken: string }
	| { status: 'loading' }
	| { status: 'expired' }
export type UserAuthStatus = UserAuth['status']

export type State = ContainerState & {
	userAuth: UserAuth
	translation: { locale: string; messages: Record<string, string> } | undefined
}
export type Store = StoreBase<State>

export const defaultState: State = {
	page: { name: 'NotFound' },
	status: ContainerStatus.Running,

	userAuth: { status: 'loading' },
	translation: undefined,
	data: {},
}

export const storeCreate = () => storeCreateBase<State>(defaultState)
